import ReactGA4 from 'react-ga4'

const googleAnalyticsUtils = {
  initializeGA4: () => {
    const trackingCode = process.env.REACT_APP_GA_TRACKING_CODE
    ReactGA4.initialize(trackingCode)
  },

  trackPageview: (pathname, title) => {
    // ReactGA4.pageview(pathname)
    ReactGA4.send({ hitType: 'pageview', page: pathname, title })
  },

  trackEvent: (eventName, attributes = {}) => {
    ReactGA4.event({
      category: 'ckd_campaign',
      action: eventName,
      ...attributes,
    })
  },

  // setUserAttributes: (userId, userProperties) => {
  //   ReactGA4.set({
  //     userId,
  //     ...userProperties,
  //   })
  // },

  setUserAttributes: (attributes) => {
    ReactGA4.set({
      userId: `${attributes.country_code}${attributes.contact_no}`,
      ...attributes,
    })
  },
}

export default googleAnalyticsUtils
